"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var date_fns_1 = require("date-fns");
var firestore_1 = require("firebase/firestore");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var react_1 = __importDefault(require("react"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var DatePicker_1 = __importDefault(require("shared/components/DateTimePicker/DatePicker"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var BillingFrequencyForm_1 = __importDefault(require("./BillingFrequencyForm"));
var SimplifiedDatepicker = (0, SimplifyFormInput_1.default)(DatePicker_1.default);
var RenewalDropdown = function (_a) {
    var _b, _c, _d;
    var onClose = _a.onClose, dropdownAnchor = _a.dropdownAnchor, serviceStat = _a.serviceStat;
    var _e = __read((0, hooks_1.useSubmitter)('service_stats', serviceStat.id), 2), updateSStat = _e[0], isUpdating = _e[1];
    var _f = __read(react_1.default.useState((_b = serviceStat.renewalDateNext) === null || _b === void 0 ? void 0 : _b.toDate()), 2), renewalDate = _f[0], setRenewalDate = _f[1];
    var toolName = ((_c = serviceStat.service) === null || _c === void 0 ? void 0 : _c.niceName) || ((_d = serviceStat.service) === null || _d === void 0 ? void 0 : _d.name);
    var _g = __read(react_1.default.useState(serviceStat.renewalFrequency), 2), frequency = _g[0], setFrequency = _g[1];
    var _h = __read(react_1.default.useState(false), 2), error = _h[0], setError = _h[1];
    var isCanceled = serviceStat.activeStatus === 'Inactive';
    var handleClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        var changes;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    changes = {};
                    if (!isCanceled && renewalDate && renewalDate < (0, date_fns_1.startOfToday)()) {
                        setError(true);
                        return [2 /*return*/];
                    }
                    if (renewalDate && renewalDate.toJSON() !== ((_a = serviceStat.renewalDateNext) === null || _a === void 0 ? void 0 : _a.toDate().toJSON())) {
                        Object.assign(changes, {
                            renewalDateStart: firestore_1.Timestamp.fromDate(renewalDate),
                            renewalDateNext: firestore_1.Timestamp.fromDate(renewalDate),
                            activeStatus: 'Active',
                        });
                        setError(false);
                    }
                    if (frequency !== serviceStat.renewalFrequency) {
                        changes.renewalFrequency = frequency;
                    }
                    if (!!(0, isEmpty_1.default)(changes)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateSStat(changes)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(DropdownMenu_1.default, __assign({ anchorEl: dropdownAnchor, open: !!dropdownAnchor, onClose: handleClose, tabIndex: -1 }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ px: 2, pb: 3, tabIndex: -1 }, { children: isCanceled
                ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ px: 0.5, py: 2 }, { children: [toolName || 'This tool', " is marked as canceled."] })), (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "small", fullWidth: true, disabled: isUpdating, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setRenewalDate(null);
                                            return [4 /*yield*/, updateSStat({ activeStatus: 'Active', renewalDateNext: null, renewalDateStart: null })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "Mark tool as active" }))] }))
                : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SimplifiedDatepicker, { disabled: isUpdating, label: "Next Payment Date", value: renewalDate, onChange: function (newDate) { return setRenewalDate(newDate); } }), error && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", color: "error" }, { children: "Dates in the past cannot be selected" })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mt: 2, mb: 4 }, { children: (0, jsx_runtime_1.jsx)(BillingFrequencyForm_1.default, { disabled: isUpdating, value: frequency, onChange: function (newFreq) { return setFrequency(newFreq); } }) })), (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "small", fullWidth: true, disabled: isUpdating || isCanceled, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setRenewalDate(null);
                                            return [4 /*yield*/, updateSStat({ activeStatus: 'Inactive', renewalDateNext: null, renewalDateStart: null })];
                                        case 1:
                                            _a.sent();
                                            onClose();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "Mark tool as canceled" }))] })) })) })));
};
exports.default = RenewalDropdown;
